// extracted by mini-css-extract-plugin
export default {"parent":"notification_parent__IKWke","info":"notification_info__dmoBM","profileinfo":"notification_profileinfo__VJJNc"};